import { defineMessages } from 'react-intl';

const messages = defineMessages({
  collapseGroup: {
    id: 'WlG8cm',
    defaultMessage: 'Collapse All',
    description: 'Aria label for collapsing a grouped notification',
  },
  expandGroup: {
    id: '2m/Syc',
    defaultMessage: 'Expand All',
    description: 'Aria label for expanding a grouped notification',
  },
});

export { messages };
